import { Container } from './styles'

export function DrawerContent({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}
